// extracted by mini-css-extract-plugin
export default {"option-item":"gYFRZFp8iiWHlX8T_tOr"};